/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewsignoffen4Inputs */

const en_letterpreviewsignoffen4 = /** @type {(inputs: Letterpreviewsignoffen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With best regards,`)
};

const pt_letterpreviewsignoffen4 = /** @type {(inputs: Letterpreviewsignoffen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With best regards,`)
};

/**
* | output |
* | --- |
* | "With best regards," |
*
* @param {Letterpreviewsignoffen4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsignoffen4 = /** @type {((inputs?: Letterpreviewsignoffen4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsignoffen4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsignoffen4(inputs)
	return pt_letterpreviewsignoffen4(inputs)
});
export { letterpreviewsignoffen4 as "letterPreviewSignoffEN" }